import { useFormik } from "formik";
import { useState } from "react";
import { useDataFetch } from "../../core/hooks/useDataFetch";
import { Config } from "../../config/config";

export const useBTFormConfig = () => {
  const { callAPI } = useDataFetch();
  const [btData, setBtData] = useState(null);
  // The payload that produced btData. Held separately from btForm.values so the
  // results keep describing the run that made them even if the form is edited
  // afterwards - Net value is derived from the budget, so a drifting figure there
  // would be quietly wrong.
  const [btRunConfig, setBtRunConfig] = useState(null);

  const btForm = useFormik({
    initialValues: {
      algoKey: "SMAPC",
      token: "",
      tradeBudget: 25000,
      profitMargin: 3,
      lossMargin: 3,
      forceExit: 10,
      years: 1,
    },
    onSubmit: async (values) => {
      setBtData(null);
      const payload = {
        ...values,
        tradeBudget: Number(values.tradeBudget),
        profitMargin: Number(values.profitMargin),
        lossMargin: Number(values.lossMargin),
        forceExit: Number(values.forceExit),
        years: Number(values.years),
      };
      const result = await callAPI(Config.ITradeAPI.doBackTesting, payload);
      if (result.status) {
        setBtData(result.data);
        setBtRunConfig(payload);
      }
    },
  });

  return { btForm, btData, btRunConfig };
};
